@if (loading) {
  <div class="loader__container">
    <div class="loader loader--fit"></div>
  </div>
}

@if (data.head.length && !loading) {
  <div class="table_container fixedTable">
    <div class="row">
      <div class="col-sm-2 no-right-padding">
        <table class="table table-bordered header-title">
          <tr>
            <th>&nbsp;</th>
          </tr>
          <tr>
            <th>Calculations</th>
          </tr>
        </table>
      </div>
      <div class="col-sm-10 no-left-padding">
        <div class="fixedTable-header">
          <table id="header-table" class="table table-bordered">
            <tr>
              @for (header of data.head; track header) {
                <th>
                  {{header.statementDate | date: 'MM/d/y'}}
                </th>
              }
            </tr>
            <tr>
              @for (header of data.head; track header) {
                <th>
                  {{translatePeriodType(header.reportingPeriod)}}
                </th>
              }
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-2 no-right-padding">
        <aside class="fixedTable-sidebar">
          <table id="sidebar-table" class="table table-bordered table-hover">
            <tbody>
              @for (obj of data.data; track obj) {
                <tr>
                  <td class="col-xs-9 title">
                    {{obj.title}}
                  </td>
                  <td class="col-xs-3 req">
                    Req.
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </aside>
      </div>
      <div class="col-sm-10 no-left-padding">
        <div class="fixedTable-body" id="body-table" (scroll)="scrollTable()">
          <table class="table table-bordered">
            @for (obj of data.data; track obj; let oper_i = $index) {
              <tr>
                @for (v of obj.requirements; track v; let row_i = $index) {
                  <td #singleCell
                    (click)="editRequiredValue(singleCell, v, obj.requirements[oper_i], data.head[row_i])"
                    class="value-container">
                    <div class="cell-value" [ngClass]="{'inherited-req-value': v.isInherited}">
                      <app-currency-component
                        [value]="v.requiredValue === null ? '---' : v.requiredValue"
                        [unitType]="obj.requirements[oper_i]?.unitType"
                        [decimalPlaces]="0">
                      </app-currency-component>
                    </div>
                  </td>
                }
              </tr>
            }
          </table>
          @if (loadingSave) {
            <div class="loadingOverlay">
              <div class="loader" style="margin-top: 20%"></div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}

@if (!data.head.length && !loading) {
  <div class="empty-list">
    <div class="row">
      <div class="col-xs-4 col-sm-offset-4 text">There are no covenants set up yet</div>
    </div>
    <div class="row">
      <div class="col-xs-4 col-sm-offset-4">
        Covenants are created once you have some statements to map
      </div>
    </div>
    <div class="row">
      <div class="col-xs-4 col-sm-offset-4">
        <a type="button" class="btn btn-default" [routerLink]="['../financials/calculation/spread']">
          Set up covenant calculations
        </a>
      </div>
    </div>
  </div>
}
